// React
import React, { useContext, useEffect, useState } from 'react';
import packageJson from '../../package.json';

// Contexts
import { AppContext, appState } from '../model/context/app/app';
import {
    emptyWorkflowStatesContextObj,
    WorkflowStatesContext,
    WorkflowStatesContextObj,
} from '../model/context/app/workflowStates';

// Components
import FooterComponent from '../components/footer/Footer.component';
import HTMLHeadComponent from '../components/HTMLhead/HTMLHead.component';
import MenuComponent from '../components/menu/Menu.component';
import RoutesComponent from '../pages/routes/Routes.component';
import fetchWorkflowStates from '../services/fetch/fetchWorkflowStates';

export default function App(): React.ReactElement {
    const { appTitle, description, language } = useContext(AppContext);
    const [token, setToken] = useState('');
    const [workflowStates, setWorkflowStates] = useState<WorkflowStatesContextObj>(emptyWorkflowStatesContextObj);

    useEffect(() => {
        if (token) {
            fetchWorkflowStates(token)
                .then((res) => setWorkflowStates({ states: res }))
                .catch((error) => {
                    setWorkflowStates({ ...emptyWorkflowStatesContextObj, error });
                });
        }
    }, [token]);

    return (
        <>
            <HTMLHeadComponent version={packageJson.version} title={appTitle} description={description} />
            <header>
                <MenuComponent language={language} onTokenChange={(newToken) => setToken(newToken)} />
            </header>
            <main className="main">
                <AppContext.Provider value={{ ...appState, token: token }}>
                    <WorkflowStatesContext.Provider value={workflowStates}>
                        <RoutesComponent />
                    </WorkflowStatesContext.Provider>
                </AppContext.Provider>
            </main>
            <FooterComponent name={packageJson.name} version={packageJson.version} />
        </>
    );
}
